var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
export default Vue.extend({
    name: 'secQueryCondition',
    props: {
        secQueryConditionConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        secOptBtns: {
            type: Array,
            default: function () {
                return [];
            },
        },
        size: {
            type: String,
            default: 'small',
        },
    },
    data: function () {
        return {
            secRuleForm: {},
        };
    },
    created: function () {
        this.init();
    },
    methods: {
        // 初始化默认选中值
        init: function () {
            var initSearch = {};
            this.secQueryConditionConfig.forEach(function (item) {
                if (item.type === 'radio') {
                    initSearch[item.key] = '';
                }
            });
            this.secRuleForm = Object.assign({}, initSearch);
        },
        callback: function (btn) {
            return btn.callback ? btn.callback() : function () { };
        },
        getParams: function () {
            this.$emit('get-sec-query-condition', __assign({}, this.secRuleForm));
        },
    },
});
